import {
  CLEAR_FISCAL_CAPITAL_BALANCE,
  CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS,
  LOAD_FISCAL_CAPITAL_BALANCE,
  LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY,
  LOAD_FISCAL_CAPITAL_BALANCE_KPIS,
  SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS,
  CLEAR_ACCOUNTING_CAPITAL_BALANCE,
  CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS,
  LOAD_ACCOUNTING_CAPITAL_BALANCE,
  LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY,
  LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS,
  SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS
} from '../actions/capitalBalanceActions';

const initialKpis = {
  activeContracts: 0,
  currentMonthFinalBalance: 0,
  termination: {
    total: 0,
    contractCount: 0,
    offendingContracts: [],
    offendingContractCount: 0
  }
};

const initialState = {
  fiscal: {
    options: { limit: +process.env.REACT_APP_TABLE_SIZE, page: 0 },
    items: [],
    count: 0,
    summary: {
      items: [],
      count: 0
    },
    kpis: initialKpis
  },
  accounting: {
    options: { limit: +process.env.REACT_APP_TABLE_SIZE, page: 0 },
    items: [],
    count: 0,
    summary: {
      items: [],
      count: 0
    },
    kpis: initialKpis
  }
};

const capitalBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FISCAL_CAPITAL_BALANCE.success: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          items: action.items,
          count: action.count
        }
      };
    }
    case SAVE_FISCAL_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          options: { ...state.fiscal.options, ...action.options }
        }
      };
    }
    case CLEAR_FISCAL_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          options: initialState.fiscal.options
        }
      };
    }
    case CLEAR_FISCAL_CAPITAL_BALANCE: {
      return {
        ...state,
        fiscal: initialState.fiscal
      };
    }
    case LOAD_ACCOUNTING_CAPITAL_BALANCE.success: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          items: action.items,
          count: action.count
        }
      };
    }
    case SAVE_ACCOUNTING_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          options: { ...state.accounting.options, ...action.options }
        }
      };
    }
    case CLEAR_ACCOUNTING_CAPITAL_BALANCE_OPTIONS: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          options: initialState.accounting.options
        }
      };
    }
    case CLEAR_ACCOUNTING_CAPITAL_BALANCE: {
      return {
        ...state,
        accounting: initialState.accounting
      };
    }
    case LOAD_FISCAL_CAPITAL_BALANCE_SUMMARY.success: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          summary: {
            items: action.items,
            count: action.count
          }
        }
      };
    }
    case LOAD_ACCOUNTING_CAPITAL_BALANCE_SUMMARY.success: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          summary: {
            items: action.items,
            count: action.count
          }
        }
      };
    }
    case LOAD_FISCAL_CAPITAL_BALANCE_KPIS.success: {
      return {
        ...state,
        fiscal: {
          ...state.fiscal,
          kpis: {
            activeContracts: action.activeContracts,
            currentMonthFinalBalance: action.currentMonthFinalBalance,
            termination: action.termination
          }
        }
      };
    }
    case LOAD_ACCOUNTING_CAPITAL_BALANCE_KPIS.success: {
      return {
        ...state,
        accounting: {
          ...state.accounting,
          kpis: {
            activeContracts: action.activeContracts,
            currentMonthFinalBalance: action.currentMonthFinalBalance,
            termination: action.termination
          }
        }
      };
    }

    default: {
      return state;
    }
  }
};

export default capitalBalanceReducer;
